import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import FormattedCurrency from 'components/ui/FormattedCurrency';
import { FormattedMessage } from 'react-intl';
import PassengerType from 'components/ui/PassengerType';
import { isInfantsOnLapEnabled } from 'utils/featureFlags';
import { mapObject } from 'utils/functions';

import { getPaxSummary } from '../../JourneyDigest.utils';
import { StyledTD } from '../../JourneyDigest.styles';

const PaxInfo = ({
  paxDetails,
  currency,
  isABSOrAdsAccessibleTravel = false,
  shouldShowBucketCode = false,
  infantCount = 0,
  isLoyaltyBooking = false
}) => {
  const infantsOnLapEnabled = isInfantsOnLapEnabled();

  return (
    <div className="travel-info pax-details">
      <table>
        <tbody>
          {paxDetails &&
            mapObject(
              (key, pax) => (
                <Fragment key={key}>
                  <tr data-testid="pax-details" data-id="pax-details">
                    <StyledTD>
                      {`${pax.count} x `}
                      <PassengerType
                        type={pax.type}
                        disabilityType={pax.disabilityType}
                        isABSOrAdsAccessibleTravel={isABSOrAdsAccessibleTravel}
                      />
                    </StyledTD>
                    <StyledTD>
                      <FormattedCurrency currency={currency} amount={pax.price || 0} />
                      {!!pax.loyaltyPoints && (
                        <span data-id="points-details">
                          <> + </>
                          <FormattedMessage id="searchResults.pts" values={{ points: pax.loyaltyPoints }} />
                        </span>
                      )}
                      {shouldShowBucketCode && ` (${pax.bucketCode})`}
                    </StyledTD>
                  </tr>
                </Fragment>
              ),
              getPaxSummary(paxDetails)
            )}
          {infantsOnLapEnabled && infantCount > 0 && (
            <tr data-testid="pax-details-infant" data-id="pax-details-infant">
              <StyledTD>
                {`${infantCount} x `}
                <FormattedMessage id="summary.infantOnLap" />
              </StyledTD>
              <StyledTD>
                <FormattedCurrency currency={currency} amount={0} />
                {isLoyaltyBooking && (
                  <span data-id="points-details">
                    <> + </>
                    <FormattedMessage id="searchResults.pts" values={{ points: 0 }} />
                  </span>
                )}
              </StyledTD>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

PaxInfo.propTypes = {
  currency: PropTypes.string,
  paxDetails: PropTypes.arrayOf(
    PropTypes.shape({
      disabilityType: PropTypes.string,
      id: PropTypes.string,
      isAFareAddOn: PropTypes.bool,
      name: PropTypes.string,
      passengerId: PropTypes.string,
      price: PropTypes.number,
      tariffCode: PropTypes.string,
      type: PropTypes.string
    })
  ),
  isABSOrAdsAccessibleTravel: PropTypes.bool,
  shouldShowBucketCode: PropTypes.bool,
  infantCount: PropTypes.number,
  isLoyaltyBooking: PropTypes.bool
};

export default PaxInfo;
